/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Zeugniserhalten1Inputs */

const de__field_zeugniserhalten1 = /** @type {(inputs: _Field_Zeugniserhalten1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeugnis erhalten`)
};

/**

* @param {_Field_Zeugniserhalten1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_zeugniserhalten1 = /** @type {((inputs?: _Field_Zeugniserhalten1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Zeugniserhalten1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_zeugniserhalten1(inputs)
});
export { _field_zeugniserhalten1 as "_field_zeugnisErhalten" }